module.exports = __webpack_public_path__ + "img/tec-para.c779a4c0.png";